'use client'
// =============================================================================
// ToolsTab — onglet TOOLS de l'AI Command Center. Deux blocs distincts,
// jamais fusionnés (voir docs/architecture/command-center-ui.md, Modèle
// mental) : Infrastructure State (services) vs Jinx/Agent Tools (actions).
// Remplace l'ancien ToolsTab (RightPanel.tsx), qui affichait des noms
// d'outils/workers/CPU/GPU codés en dur (jamais de vraie exécution derrière).
// =============================================================================
import { InfraStatus } from '../widgets/InfraStatus'
import { ToolList } from '../widgets/ToolList'

export function ToolsTab() {
  return (
    <>
      <InfraStatus />
      <ToolList />
    </>
  )
}
